import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let RulesDiv = class RulesDiv extends Vue {
    constructor() {
        super(...arguments);
        this.t = `<p>1、每人每天3次抽奖机会，每分享1次即可获得额外1次抽奖机会，每天最多5次抽奖机会；</p>
        <p>2、奖品图片仅供参考，奖品颜色、大小等均以实物为准；</p>
        <p>3、实物奖品将在活动结束后10个工作日之内发出；</p>
        <p>4、活动领奖日期截止到2019年2月28日，逾期未领视为自动放弃奖励；</p>
        <p>5、恶意刷奖者，有权取消其所有活动奖励；</p>
        <p>6、本次活动最终解释权归常青藤爸爸（北京）教育科技有限公司所有。</p>`;
    }
};
tslib_1.__decorate([
    Prop()
], RulesDiv.prototype, "close", void 0);
tslib_1.__decorate([
    Prop()
], RulesDiv.prototype, "rule", void 0);
tslib_1.__decorate([
    Prop()
], RulesDiv.prototype, "background", void 0);
RulesDiv = tslib_1.__decorate([
    Component
], RulesDiv);
export default RulesDiv;
